"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = _interopRequireDefault(require("react-jss"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Badge = _interopRequireDefault(require("../Badge"));
var _Button = _interopRequireDefault(require("../Button"));
var _Stack = _interopRequireDefault(require("../Stack"));
var _SpacedLabel = _interopRequireDefault(require("../SpacedLabel"));
var _utils = _interopRequireDefault(require("../utils/utils"));
var _TextField = _interopRequireDefault(require("./TextField.style"));
var _Popover = _interopRequireDefault(require("../Popover"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _constants = require("../constants");
var _hooks = require("../hooks");
var _TextFieldInner = _interopRequireDefault(require("./TextFieldInner"));
const _excluded = ["calendar", "value", "visibility", "onBlur", "id", "colorPicker", "error", "type", "onChange", "onFocus", "onKeyPress", "onPaste", "onReset", "autoSelect", "toggleFocus", "autoFocus", "regexp", "mask", "maskOptions", "length", "required", "leftIcon", "rightIcon", "popover", "popoverOptions", "onClickRightIcon", "startAdornment", "endAdornment", "size", "bordered", "unspaced", "resettable", "helperText", "placeholder", "label", "tooltip", "multilineType", "multilineSpellCheck", "color", "className", "classes", "forwardRef", "autoComplete", "trimOnOutsideClick", "rows", "dataTestId"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TEXT_FIELD_COLOR = _utils.default.pick(_constants.COLOR, ['white']);
const AUTO_SELECT = {
  true: true,
  // Text will be auto-selected in all cases
  false: false,
  // Disable text autoselection
  // Below are triggers specific cases of text autoselection
  focus: 'focus',
  mount: 'mount'
};
const TextFieldPropTypes = {
  classes: _propTypes.default.object,
  /** text field's type */
  type: _propTypes.default.oneOf(['text', 'password', 'phone', 'email', 'int', 'float']),
  /** text field's size */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /** text field's visibility */
  visibility: _propTypes.default.oneOf(['visible', 'disabled', 'hidden']),
  /** Does text field's has an error */
  error: _propTypes.default.bool,
  /** text field's helper text under input */
  helperText: _propTypes.default.string,
  /** text field's label */
  label: _propTypes.default.node,
  /** text field's tooltip */
  tooltip: _propTypes.default.string,
  /** Background color */
  color: _propTypes.default.oneOf(Object.keys(TEXT_FIELD_COLOR)),
  /** If true - default component paddings and margins will be removed */
  unspaced: _propTypes.default.bool,
  /** Is text field required? */
  required: _propTypes.default.bool,
  /** text field's value */
  value: _propTypes.default.string,
  /** text field's regular expression */
  regexp: _propTypes.default.string,
  /** text field's length */
  length: _propTypes.default.number,
  /** text field's left icon */
  leftIcon: _propTypes.default.string,
  /** text field's right icon */
  rightIcon: _propTypes.default.string,
  /** placeholder */
  placeholder: _propTypes.default.string,
  /** input autoFocus */
  autoFocus: _propTypes.default.bool,
  /** input autoSelect -  defines if input text should be automatically selected and in what cases */
  autoSelect: _propTypes.default.oneOf(Object.keys(AUTO_SELECT)),
  /** additional external class name */
  className: _propTypes.default.string,
  /** element id */
  id: _propTypes.default.string,
  /** onChange callback */
  onChange: _propTypes.default.func,
  /** onFocus callback */
  onFocus: _propTypes.default.func,
  /** input toggleFocus */
  toggleFocus: _propTypes.default.bool,
  /** onBlur callback */
  onBlur: _propTypes.default.func,
  /** onKeyPress callback */
  onKeyPress: _propTypes.default.func,
  /** onKeyUp callback */
  onKeyUp: _propTypes.default.func,
  /** onKeyDown callback */
  onKeyDown: _propTypes.default.func,
  /** callback for pasting from clipboard in html type */
  onUpload: _propTypes.default.func,
  /** onClickRightIcon callback */
  onClickRightIcon: _propTypes.default.func,
  /** onReset callback */
  onReset: _propTypes.default.func,
  /** Any element that could be rendered as popover content */
  popover: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
  /**
   * Calendar
   * @deprecated use popover instead
   */
  calendar: _propTypes.default.func,
  /**
   * Color picker
   * @deprecated use popover instead
   */
  colorPicker: _propTypes.default.func,
  /** Multiline field */
  multiline: _propTypes.default.bool,
  /** Multiline type */
  multilineType: _propTypes.default.oneOf(['text', 'html']),
  /** Multiline spellCheck */
  multilineSpellCheck: _propTypes.default.bool,
  /** Numbers of rows (only for multiline field) */
  rows: _propTypes.default.number,
  /** Use that property to pass a ref callback to the native input component. */
  forwardRef: _propTypes.default.object,
  /** bordered field */
  bordered: _propTypes.default.bool,
  /** If true - text-field value could be reset with a close button */
  resettable: _propTypes.default.bool,
  /** read only field */
  readOnly: _propTypes.default.bool,
  /** input mode to decide which keyboard to display */
  inputMode: _propTypes.default.oneOf(['none', 'text', 'decimal', 'tel', 'email', 'url']),
  /** Mask (could only be applied on input) */
  mask: _propTypes.default.string,
  /** Additional settings for mask property */
  maskOptions: {
    lazy: _propTypes.default.bool,
    // If false - placeholder will be always visible
    placeholderChar: _propTypes.default.string // default is '_' in imask
  },
  /** options for react portal render of field popups **/
  popoverOptions: _propTypes.default.object,
  /** This can be used to add a prefix or an action to an input (icon, button, etc.) */
  startAdornment: _propTypes.default.node,
  /** This can be used to add a suffix or an action to an input (icon, button, etc.) */
  endAdornment: _propTypes.default.node,
  /** This is a type of input autoComplete */
  autoComplete: _propTypes.default.string,
  /**
   * Should TextField value be trimmed when click outside. Initially aded to avoid unneeded onChange calls when use
   * TextField inside Select with "autocomplete" type when clicking on one of the menu items of the select and have
   * 2 onChange calls (1 - for iteme select, 2 - for trimm and outside click).
   * Other fixes lead only to more bugs (Select, TextField and ContentEditable should be rewritten)
   */
  trimOnOutsideClick: _propTypes.default.bool,
  /** Used for automated testing */
  dataTestId: _propTypes.default.string
};

// get input type
const getInputType = (type, passShow) => {
  if (type === 'int') return 'number';
  return type === 'password' && !passShow ? 'password' : 'text';
};
const StyledTextField = (0, _reactJss.default)(_TextField.default)(_react.default.memo(_ref => {
  let {
      calendar,
      value,
      visibility,
      onBlur,
      id,
      colorPicker,
      error,
      type,
      onChange,
      onFocus,
      onKeyPress,
      onPaste,
      onReset,
      autoSelect,
      toggleFocus,
      autoFocus,
      regexp,
      mask,
      maskOptions,
      length,
      required,
      leftIcon: leftIconProp,
      rightIcon,
      popover,
      popoverOptions,
      onClickRightIcon,
      startAdornment,
      endAdornment,
      size,
      bordered,
      unspaced,
      resettable,
      helperText,
      placeholder,
      label,
      tooltip,
      multilineType,
      multilineSpellCheck,
      color,
      className,
      classes,
      forwardRef,
      autoComplete,
      trimOnOutsideClick,
      rows,
      dataTestId
    } = _ref,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const recognizedRest = (0, _hooks.useRecognizedProps)(rest, TextFieldPropTypes);
  const inputRef = (0, _react.useRef)();
  const txtElRef = (0, _react.useRef)();
  const valueRef = (0, _react.useRef)(value);
  const isFirstRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(() => {
    // Initialize outer ref
    if (forwardRef) {
      forwardRef.current = inputRef.current;
    }
  }, []);
  (0, _react.useEffect)(() => {
    if (inputRef.current && autoSelect === true || autoSelect === AUTO_SELECT.mount) {
      inputRef.current.select();
    }
  }, [inputRef, autoSelect]);
  const [state, setState] = (0, _hooks.useObjectState)({
    passShow: false,
    focus: false,
    error: Boolean(value),
    autoSelected: false
  });

  // blur for field
  const handleBlur = (0, _react.useCallback)(() => {
    if (!_utils.default.isVisible(visibility)) return;
    inputRef.current.blur();
    if (!calendar && !colorPicker) {
      setState.focus(false);
    }
    onBlur(id);
  }, [calendar, visibility, onBlur, id, colorPicker]);

  // focus for field
  const handleFocus = (0, _react.useCallback)(() => {
    if (!_utils.default.isVisible(visibility)) return;
    if (!toggleFocus) inputRef.current.focus();
    if (autoSelect === true || autoSelect === AUTO_SELECT.focus && !state.autoSelected) {
      setTimeout(() => {
        if (inputRef.current) inputRef.current.select();
      }, 0);
    }
    setState.focus(true);
    setState.autoSelected(autoSelect ? !state.autoSelected : false);
    if (toggleFocus && state.focus) {
      handleBlur();
    } else {
      onFocus(id);
    }
  }, [visibility, onFocus, id, autoSelect, toggleFocus, handleBlur, inputRef, state.focus, state.autoSelected]);
  (0, _react.useEffect)(() => autoFocus ? handleFocus() : undefined, [autoFocus]);
  (0, _react.useEffect)(() => {
    setState.error(Boolean(value));
    valueRef.current = value;
  }, [valueRef, value]);
  const handleClickOutside = (0, _react.useCallback)(e => {
    if (txtElRef.current && txtElRef.current.contains(e.target)) return;
    if (!calendar && !colorPicker) {
      setState.focus(false);
    }

    // Reference used because we don't want reassign outside click listeners each time value changes
    const value = valueRef.current;

    // trim value
    const trimTypes = ['text', 'email'];
    if (trimOnOutsideClick && value && typeof value === 'string' && trimTypes.includes(type) && value !== value.trim()) {
      valueRef.current = value.trim();
      onChange({
        id,
        value,
        error
      }, e);
    }
    onBlur();
  }, [id, valueRef, error, type, onBlur, onChange, calendar, colorPicker, txtElRef, state.focus, trimOnOutsideClick]);
  (0, _hooks.useOutside)({
    ref: txtElRef,
    callback: handleClickOutside,
    triggers: ['click', 'contextmenu']
  });

  // Handle change for single line field
  const validateChanges = (0, _react.useCallback)(arg => {
    let value = arg.value !== undefined ? arg.value : arg.target.value;
    let error = false;

    // Checking and formating
    if (type === 'email') {
      // eslint-disable-next-line max-len
      const re = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-line
      if (!re.test(String(value))) {
        error = true;
      }
    }
    // Formatting type int
    if (type === 'int' || type === 'phone' && /\D/g.test(value)) {
      value = value.replace(/\D/g, '');
      if (type === 'int' && value !== '') {
        value = Number(value);
      }
    }

    // Restriction by string length
    if (length && value.length >= length) {
      value = value.substr(0, length);
    }
    // check regexp
    if (regexp) {
      const r = new RegExp(regexp);
      error = !r.test(value.trim());
    }
    if (required && (!value || !value.length)) {
      error = true;
    }
    valueRef.current = value;
    return {
      id,
      error,
      value
    };
  }, [id, regexp, type, length, required]);

  // Revalidate value if related props changed
  (0, _react.useEffect)(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    onChange(validateChanges({
      value: valueRef.current
    }));
  }, [validateChanges, valueRef, id, regexp, type, length, required]);
  const handleChange = (0, _react.useCallback)(e => {
    onChange(validateChanges(e), e);
  }, [validateChanges, onChange]);

  /**
   * Validates an event (for example keyPress or paste) for a float type input.
   * If potential value is invalid - then prevent user from typing, otherwise act as usual user typing
   *
   * WARNING:
   * There is bugs in native DOM input element with "type: number", especially with dots (.) and commas (,) typing
   * @see Details on: https://codepen.io/whazam/pen/oOWxPK
   *
   * So decided to use regular input with "type: text" with manual validation
   * in case when we use float values on the TextField
   */
  const validateEventForFloatType = (0, _react.useCallback)(({
    event,
    candidateValue,
    callback
  }) => {
    if (candidateValue && /^[+-]?([0-9]*([.][0-9]*)?|[.][0-9]+)$/.test(candidateValue)) {
      callback(event);
      return;
    }
    event.preventDefault();
  }, [type]);
  const handleKeyPress = (0, _react.useCallback)(e => {
    if (type !== 'float') {
      onKeyPress(e);
      return;
    }
    const {
      selectionStart,
      selectionEnd,
      value
    } = e.target;
    validateEventForFloatType({
      event: e,
      candidateValue: value.slice(0, selectionStart) + e.key + value.slice(selectionEnd),
      callback: onKeyPress
    });
  }, [onKeyPress]);
  const handlePasteFloat = (0, _react.useCallback)(e => {
    const pastedText = (e.clipboardData || window.clipboardData).getData('text');
    const {
      selectionStart,
      selectionEnd,
      value
    } = e.target;
    validateEventForFloatType({
      event: e,
      candidateValue: value.slice(0, selectionStart) + pastedText + value.slice(selectionEnd),
      callback: onPaste
    });
  }, [onPaste]);

  // show/hide password
  const togglePass = (0, _react.useCallback)(() => setState.passShow(!state.passShow), [state.passShow]);
  const renderPlaceholder = (0, _react.useCallback)(() => {
    if (!placeholder) return null;
    const selected = Boolean(value || state.focus);
    if (size === 'small' || selected || !label && !selected || bordered) return placeholder;
  }, [placeholder, size, label, bordered, value, state.focus]);
  const renderLabelComponent = (0, _react.useCallback)(() => {
    if ((0, _react.isValidElement)(label)) return label;
    if (!bordered && size === 'small') return null;
    const wrapperClassName = (0, _clsx.default)(classes.label, tooltip ? 'tooltip' : 'label', {
      unspaced
    });
    return tooltip ? /*#__PURE__*/_react.default.createElement(_Stack.default.H, {
      size: "xxsmall",
      alignItems: "center",
      className: wrapperClassName,
      onClick: handleFocus
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "label"
    }, label), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
      value: tooltip,
      topLevel: true
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "small",
      type: "info",
      colorType: state.focus && !error ? _constants.COLOR.primary : _constants.COLOR.gray
    }))) : /*#__PURE__*/_react.default.createElement("div", {
      className: wrapperClassName,
      onClick: handleFocus
    }, label);
  }, [tooltip, label, bordered, size, handleFocus, classes.label, state.focus, error]);
  let leftIcon = type === 'phone' ? 'plus' : leftIconProp;
  leftIcon = calendar ? 'calendar' : leftIcon;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: (0, _clsx.default)(className, classes.txt, classes[size], {
      error: Boolean(error)
    }, {
      hidden: visibility === 'hidden'
    }, {
      disabled: visibility === 'disabled'
    }, {
      focus: Boolean(state.focus)
    },
    /**
     * If there is something in the field (value, cursor or mask placeholder)
     * than should be additional styles applied
     */
    {
      selected: Boolean(value || state.focus || mask && maskOptions.lazy === false)
    }, {
      hasLeftIcon: Boolean(leftIcon)
    }, {
      bordered
    }, {
      unspaced
    }),
    ref: txtElRef,
    "data-testid": `${dataTestId}-container`
  }, /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({
    content: ({
      onClose
    }) => {
      if (!(popover || calendar || colorPicker)) return null;

      // TOMAKE: remove this block after calendar and colorPicker props replacing with popover
      if (calendar || colorPicker) {
        return _react.default.cloneElement((calendar || colorPicker)(), {
          onSubmit: onClose,
          onClose
        });
      }
      return (0, _react.isValidElement)(popover) ? popover : popover({
        onClose
      });
    },
    bindingElementRef: txtElRef,
    contentClassName: (0, _clsx.default)(classes.popup, {
      unspaced
    }),
    anchors: {
      binding: _Popover.default.ANCHOR.left_bottom,
      content: _Popover.default.ANCHOR.left_top
    },
    topLevel: true
  }, popoverOptions, {
    onClose: (...args) => {
      if (popoverOptions.onClose) {
        popoverOptions.onClose(...args);
      }
      setState.focus(false);
      onBlur(...args);
    }
  }), ({
    onClick: _onClick
  }) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label ? renderLabelComponent() : null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.field, 'field', classes[`backgroundColor__${color}`]),
    onClick: (...args) => {
      if (_onClick && visibility === 'visible') {
        _onClick(...args);
        handleFocus(...args);
      }
    }
  }, leftIcon ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.leftIcon, 'leftIcon')
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: leftIcon,
    error: error,
    size: bordered && size === 'small' ? 'small' : 'medium'
  })) : null, startAdornment ? /*#__PURE__*/_react.default.createElement("div", {
    className: "startAdornment"
  }, startAdornment) : null, colorPicker ? /*#__PURE__*/_react.default.createElement(_Badge.default, {
    className: classes.colorBadge,
    size: "large",
    bgColor: value
  }) : null, /*#__PURE__*/_react.default.createElement(_TextFieldInner.default, (0, _extends2.default)({
    id: id,
    type: getInputType(type, state.passShow),
    visibility: visibility,
    value: value,
    multilineType: multilineType,
    multilineSpellCheck: multilineSpellCheck,
    onBlur: handleBlur,
    onChange: handleChange,
    inputRef: inputRef,
    placeholder: renderPlaceholder(),
    mask: mask,
    maskOptions: maskOptions,
    onKeyPress: handleKeyPress,
    autoComplete: autoComplete,
    rows: rows,
    dataTestId: dataTestId
  }, type === 'float' ? {
    onPaste: handlePasteFloat
  } : {
    onPaste
  }, recognizedRest)), endAdornment || resettable && value ? /*#__PURE__*/_react.default.createElement(_Stack.default, {
    className: "endAdornment",
    alignItems: "center",
    horizontal: true,
    size: _Stack.default.SIZE.none
  }, endAdornment, resettable && value ? /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "text",
    size: "xsmall",
    icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
      size: "small",
      type: "close"
    }),
    onClick: (e, ...args) => {
      handleChange({
        value: ''
      });
      if (onReset) {
        onReset(e, ...args);
      }
      e.stopPropagation();
    }
  }) : null) : null, rightIcon ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.rightIcon, 'rightIcon'),
    onClick: onClickRightIcon
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: rightIcon,
    error: error,
    size: bordered && size === 'small' ? 'small' : 'medium'
  })) : null, type === 'password' ? /*#__PURE__*/_react.default.createElement("div", {
    onClick: togglePass
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: state.passShow ? 'no_eye' : 'eye',
    size: bordered && size === 'small' ? 'small' : 'medium',
    className: classes.passIcon
  })) : null, type === 'password' ? /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'none'
    }
  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "text"
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "password"
  })) : null), helperText ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.helperText, {
      error
    })
  }, helperText) : null)));
}));
const TextField = props => /*#__PURE__*/_react.default.createElement(StyledTextField, props);
TextField.Label = _SpacedLabel.default;
TextField.COLOR = TEXT_FIELD_COLOR;
TextField.AUTO_SELECT = AUTO_SELECT;
TextField.defaultProps = {
  type: 'text',
  size: 'medium',
  visibility: 'visible',
  error: false,
  location: 'en',
  calendar: null,
  colorPicker: null,
  multiline: false,
  multilineType: 'html',
  readOnly: false,
  toggleFocus: false,
  autoSelect: AUTO_SELECT.false,
  autoComplete: 'off',
  trimOnOutsideClick: true,
  maskOptions: {},
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {},
  onClickRightIcon: () => {},
  onKeyPress: () => {},
  onKeyUp: () => {},
  onKeyDown: () => {},
  onUpload: () => {},
  onPaste: () => {},
  bordered: false,
  inputMode: 'text',
  popoverOptions: {}
};
var _default = exports.default = TextField;